import { Console } from '@plopix/js-console/dist/ts/Console';

import { NO_OMIT_COMMENTS } from '../constants/Env';

const Logger = new Console();
Logger.verbosity = NO_OMIT_COMMENTS ? 0 : 400;
Logger.logOnLoad();

export default Logger;
